import { chakraComponents, GroupBase, OptionProps } from 'chakra-react-select';
import { DetailedHTMLPropsWithTestId } from '../types';

export const Option = <OptionType extends {}>(
  props: OptionProps<OptionType, false, GroupBase<OptionType>>
) => {
  const {
    innerProps,
    selectProps: { dataTestId },
  } = props;

  return (
    <chakraComponents.Option
      {...props}
      innerProps={
        {
          ...innerProps,
          'data-testid': `${dataTestId}-option`,
        } as DetailedHTMLPropsWithTestId
      }
    />
  );
};
